import React from 'react'
import "../Text/Text.css";
import MovePoster from '../MovePoster/MovePoster';
import { IoCall } from "react-icons/io5";
import { FaWpforms } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
const Text2 = () => {
  const navigate = useNavigate();
  const calladmin = () => {
   
    window.location.href = "tel:02039449931";
  };
  const handleBookNow = () => {
    navigate("/");
  };
  return (
    <>
   <div className="text-center p-8">
  <h2 className="text-2xl font-bold mb-4 he">Your Trip, Just a Click Away</h2>
  <p className="het">
  Your time is valuable—so why spend it searching for flights? Our dedicated consultants do the legwork for you, finding premium first-class deals and arranging every detail, from exclusive lounges to seamless car hire. Travel smarter, fly in style, and save more.
  </p>
 {/*-- <p className="het">
    We secure the best first-class fares and handle extras like lounges and car hire, saving you time while ensuring a seamless journey.
  </p>
  -*/}
</div>

    <MovePoster/>
    <div className="text-center p-8">
      <h2 className="text-2xl font-bold mb-4 he">Effortless Boarding, Expert Spending</h2>
      {/*-
      <p className="het">Journey Experts arranges premium flights worldwide. Fly from the UK to Asia, Australasia, the Middle East, America, and beyond. Enjoy first-class luxury at exceptional prices with a personalized itinerary tailored to your needs. Experience comfort, convenience, and seamless travel with our expert service.</p>
-*/}
      <p className="het">Your dream destination is closer than you think. Journey Experts unlocks premium flight deals from the UK to Asia, America, the Middle East, and more—without the premium price tag. Travel first class, stress-free, and let us build an itinerary tailored to you</p>
      <p className="het">For best deal call us today on <span className='text-span' onClick={calladmin}> <IoCall /> 02039449931</span> , or fill in our online <span className='text-span' onClick={handleBookNow}> <FaWpforms /> enquiry form</span> so we can get back to you.</p>
    </div>
    </>
  )
}

export default Text2